import { reactive } from 'vue';

export const criarTpDocGrupo = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdtpdocgrupo: 0,
        nmtpdocgrupo: '',
        informacoes: '',
        ativo: 'S',
        idlogin: 0
    });
};